import { FC } from 'react';
import { Box, Tooltip } from '@mui/material';
import { isAfter } from 'date-fns';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import { LoadingSkeleton } from './loadingSkeleton';
import { DataField } from '../../../shared/components/dataField';
import { format } from '../../../shared/logic/dates';
import { useGetEquipmentQuery } from '../../../shared/redux/rental';

export const GpsTab: FC<{id: string | number}> = ({ id }) => {
  const { data: equipment, isLoading } = useGetEquipmentQuery(id);

  if (!equipment || isLoading) return <LoadingSkeleton />;

  return (
    <Box display="flex" flexWrap="wrap" alignItems="stretch" flexDirection="row" gap={2}>
      <DataField label="Smartnett bruker" sx={{ flex: '1 1 40%' }}>
        {equipment.gpsData?.referenceUsername || '\u00A0'}
      </DataField>
      <DataField label="Sim kort 1 nummer (mottaker)" sx={{ flex: '1 1 40%' }}>
        {equipment.gpsData?.simCardReceiverNumber || '\u00A0'}
      </DataField>
      <DataField label="Sim kort 2 nummer (skjerm)" sx={{ flex: '1 1 40%' }}>
        {equipment.gpsData?.simCardScreenNumber || '\u00A0'}
      </DataField>
      <DataField label="Sim kort 1 leverandør" sx={{ flex: '1 1 40%' }}>
        {equipment.gpsData?.simCardProvider || '\u00A0'}
      </DataField>
      <DataField
        label="Neste CE godkjennelse"
        sx={{ flex: '1 1 40%' }}
      >
        <Box display="flex" gap={1} alignItems="center" color="black">

          {!equipment.nextCertificationDate
            ? '\u00A0'
            : format(new Date(equipment.nextCertificationDate), 'dd.MM.yyyy')}
          {equipment.nextCertificationDate && isAfter(new Date(), new Date(equipment.nextCertificationDate))
            ? (
              <Tooltip
                title="Neste service"
                followCursor
                placement="right-start"
                enterDelay={300}
                enterNextDelay={300}
                arrow
              >
                <EventBusyIcon color="error" sx={{ alignSelf: 'center', fontSize: '25px' }} />
              </Tooltip>
            )
            : null}
        </Box>
      </DataField>
    </Box>
  );
};
